/**
 * Mobile-browser detection for the signup passkey step: on a phone the
 * passkey is registered directly on the device — showing a QR would ask the
 * user to scan their own screen.
 */
export function isMobileDevice(): boolean {
  const uaData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (typeof uaData?.mobile === "boolean") return uaData.mobile;
  return /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
}
